import "./TradeIdeasWidgetComponent.scss";
import template from "./TradeIdeasWidgetComponent.html";
import {IComponentOptions, IOnDestroy} from "angular";
import {BreakpointObserver} from "../../../../../services/breakpoints/BreakpointObserver";
import {Observable, ReplaySubject} from "rxjs";
import {Breakpoint} from "../../../../../services/breakpoints/Breakpoint";
import {WidgetDisplayMode} from "../../../models/WidgetDisplayMode";

export const TradeIdeasWidget = "tfTradeIdeasWidget";

export function tradeIdeasWidget(): IComponentOptions {
    return {
        template,
        bindings: {
            displayType: "<"
        },
        controllerAs: "ctrl",
        controller: TradeIdeasWidgetController
    };
}

type ViewType = "mobile" | "desktop";

export class TradeIdeasWidgetController implements IOnDestroy {

    /** @input */
    public set displayMode(displayMode: WidgetDisplayMode | null) {
        if (displayMode != null) {
            this.displayMode$.next(displayMode);
        }
    }

    private readonly displayMode$ = new ReplaySubject<WidgetDisplayMode>(1);

    public readonly viewType$: Observable<ViewType>;
    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private readonly breakpointObserver: BreakpointObserver) {

        this.viewType$ = this.breakpointObserver
                             .takeUntil(this.destroyed$)
                             .map(change => change.current)
                             .map((current) => this.breakpointToType(current));
    }

    private breakpointToType(breakpoint: Breakpoint): ViewType {
        switch (breakpoint) {
            case Breakpoint.XL:
            case Breakpoint.LG:
            case Breakpoint.MD:
                return  "desktop";
            case Breakpoint.SM:
            case Breakpoint.XS:
                return  "mobile";
            default:
                return "desktop";
        }
    }

    public $onDestroy() {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
